import loadable from "@loadable/component";

export const UserManagementList = loadable(() => import("./user-management/list"), {
  resolveComponent: ({ UserManagementList }) => UserManagementList,
});

export const UserManagementDetail = loadable(() => import("./user-management/detail"), {
  resolveComponent: ({ UserManagementDetail }) => UserManagementDetail,
});

export const CustomerManagementList = loadable(() => import("./customer-management/list"), {
  resolveComponent: ({ CustomerManagementList }) => CustomerManagementList,
});

export const CustomerManagementDetail = loadable(() => import("./customer-management/detail"), {
  resolveComponent: ({ CustomerManagementDetail }) => CustomerManagementDetail,
});

export const PassUserManagementList = loadable(() => import("./passuser-management/list"), {
  resolveComponent: ({ PassUserManagementList }) => PassUserManagementList,
});

export const PassUserManagementDetail = loadable(() => import("./passuser-management/detail"), {
  resolveComponent: ({ PassUserManagementDetail }) => PassUserManagementDetail,
});
